//URL base do servidor Node.js
export const baseUrl = 'https://bibliotecacatolica.com.br:5000';
